import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/layout/Default.js";
import ChipExample from './example.js';
import ChipOutline from './chipOutline.js';
import ChipSize from './chipSize.js';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Usage`}</h2>
    <p>{`Chips allow users to enter information, make selections, filter content, or trigger actions.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Chip } from 'legion-ui';
`}</code></pre>
    <div className="divi" />
    <h2><strong parentName="h2">{`Variants`}</strong></h2>
    <p>{`Legion have two variant of chips`}</p>
    <h3><strong parentName="h3">{`Soft`}</strong></h3>
    <ChipExample mdxType="ChipExample" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Chip label='primary clickable' onClick={handleChipClick} />
<Chip
  label='tertiary clickable'
  color='tertiary'
  onClick={handleChipClick}
  style={{ margin: '0 6px' }}
/>
<Chip
  label='Delete me'
  color='error'
  rightIcon={<DynamicIcon name="XCircle" size="16" />}
  onClick={deleteChip}
  style={{ marginRight: '12px' }}
/>
<Chip
  label='success!'
  color='success'
  leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
/>
<Chip
  label='warning'
  color='warning'
  style={{ margin: '0 6px' }}
/>
<Chip
  label='Chip with avatar'
  color='info'
  avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
/>
`}</code></pre>
    <h3><strong parentName="h3">{`Outline`}</strong></h3>
    <ChipOutline mdxType="ChipOutline" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<Chip label="primary clickable"  variant="outline" onClick={handleChipClick} />
<Chip
  label="tertiary clickable"
  variant="outline"
  color="tertiary"
  onClick={handleChipClick}
  style={{ margin: "0 6px" }}
/>
<Chip
  label="Delete me"
  variant="outline"
  color="error"
  rightIcon={<DynamicIcon name="XCircle" size="16" />}
  onClick={deleteChip}
  style={{ marginRight: "12px" }}
/>
<Chip
  label="success!"
  variant="outline"
  color="success"
  leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
/>
<Chip
  label="warning"
  variant="outline"
  color="warning"
  style={{ margin: "0 6px" }}
/>
<Chip
  label="Chip with avatar"
  variant="outline"
  color="info"
  avatar={
    <Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />
  }
/>
`}</code></pre>
    <div className="divi" />
    <h2>{`Attribute`}</h2>
    <p>{`You can customize chips with attributes, chips in legion have only one attribute which is size`}</p>
    <h3><strong parentName="h3">{`Size`}</strong></h3>
    <p>{`The checkbox has three sizes `}<inlineCode parentName="p">{`lg`}</inlineCode>{` , `}<inlineCode parentName="p">{`md`}</inlineCode>{` and `}<inlineCode parentName="p">{`sm`}</inlineCode></p>
    <ChipSize mdxType="ChipSize" />
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`<div>
  <div>
    <h4>Large</h4>
    <Chip label="primary clickable" variant="outline" size="lg" onClick={handleChipClick} />
    <Chip
      label="tertiary clickable"
      size="lg"
      variant="outline"
      color="tertiary"
      onClick={handleChipClick}
      style={{ margin: '0 6px' }}
    />
    <Chip
      label="Delete me"
      size="lg"
      variant="outline"
      color="error"
      rightIcon={<DynamicIcon name="XCircle" size="16" />}
      onClick={deleteChip}
      style={{ marginRight: '12px' }}
    />
    <Chip
      label="success!"
      size="lg"
      variant="outline"
      color="success"
      leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
    />
    <Chip label="warning" size="lg" variant="outline" color="warning" style={{ margin: '0 6px' }} />
    <Chip
      label="Chip with avatar"
      size="lg"
      variant="outline"
      color="info"
      avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
    />
  </div>
  <div style={{ marginTop: '1rem' }}>
    <h4>Medium</h4>
    <Chip label="primary clickable" variant="outline" size="md" onClick={handleChipClick} />
    <Chip
      label="tertiary clickable"
      size="md"
      variant="outline"
      color="tertiary"
      onClick={handleChipClick}
      style={{ margin: '0 6px' }}
    />
    <Chip
      label="Delete me"
      size="md"
      variant="outline"
      color="error"
      rightIcon={<DynamicIcon name="XCircle" size="16" />}
      onClick={deleteChip}
      style={{ marginRight: '12px' }}
    />
    <Chip
      label="success!"
      size="md"
      variant="outline"
      color="success"
      leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
    />
    <Chip label="warning" size="md" variant="outline" color="warning" style={{ margin: '0 6px' }} />
    <Chip
      label="Chip with avatar"
      size="md"
      variant="outline"
      color="info"
      avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
    />
  </div>
  <div style={{ marginTop: '1rem' }}>
    <h4>Small</h4>
    <Chip label="primary clickable" variant="outline" size="sm" onClick={handleChipClick} />
    <Chip
      label="tertiary clickable"
      size="sm"
      variant="outline"
      color="tertiary"
      onClick={handleChipClick}
      style={{ margin: '0 6px' }}
    />
    <Chip
      label="Delete me"
      size="sm"
      variant="outline"
      color="error"
      rightIcon={<DynamicIcon name="XCircle" size="16" />}
      onClick={deleteChip}
      style={{ marginRight: '12px' }}
    />
    <Chip
      label="success!"
      size="sm"
      variant="outline"
      color="success"
      leftIcon={<DynamicIcon name="CheckCircle" size="16" />}
    />
    <Chip label="warning" size="sm" variant="outline" color="warning" style={{ margin: '0 6px' }} />
    <Chip
      label="Chip with avatar"
      size="sm"
      variant="outline"
      color="info"
      avatar={<Avatar src="https://rickandmortyapi.com/api/character/avatar/192.jpeg" />}
    />
  </div>
</div>
`}</code></pre>
    <div className="divi" />
    <h2>{`Props`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`property`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`propType`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`required`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`avatar`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets Avatar in the left side (can be filled with legion-ui’s `}<inlineCode parentName="td">{`Avatar`}</inlineCode>{` component)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`color`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`primary`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`tertiary`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`error`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`warning`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`success`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`info`}</inlineCode>{` `}{`|`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`primary`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the color of the chip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`label`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`string`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets chip label`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`leftIcon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets chip icon in the left side, can be filled with legion-ui’s `}<inlineCode parentName="td">{`DynamicIcon`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`onClick`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`(e: React.ChangeEvent<HTMLInputElement>) => void`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Define chip onClick event. This will turn chip into clickable mode (pressed state), while undefined onClick props, will make chip just like a label (can be used to disabled state)`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`rightIcon`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`React.ReactNode`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets chip icon in the right side, can be filled with legion-ui’s `}<inlineCode parentName="td">{`DynamicIcon`}</inlineCode>{` component`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`sm`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`md`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`lg`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`md`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets size of the chip`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`variant`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`soft`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`outline`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`-`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`soft`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets variant of the chip`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      